import Swiper, { Pagination, Scrollbar, A11y, Keyboard } from 'swiper';

// Styles
import './_feature-panel.scss';
import 'snippets/video-player/video-block';
import 'snippets/_containers/modal/modal';
import 'snippets/swiper-control/swiper-control';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

const CAROUSEL_SELECTOR = '.carousel--feature-panel';
const CAROUSEL_CLASS = 'carousel--feature-panel';
const CAROUSEL_SECTION_SELECTOR = '.feature-panel';
const CAROUSEL_SCROLLBAR_SELECTOR = '.swiper-scrollbar';


document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {

        // Generate unique class for each collection list slider
        element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

        // Generate unique btn classes for scroll bar
        element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-scrollbar-${index}`);

        const slides = element.querySelectorAll('.swiper-slide');

        const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
            // Optional parameters
            modules: [Pagination, Scrollbar, A11y, Keyboard],
            slidesPerView: 1.2,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: slides.length == 2 ? 2 : 3,
                    spaceBetween: 5
                }
            },
            scrollbar: {
                el: `.${CAROUSEL_CLASS}-scrollbar-${index}`,
                draggable: true
            },
        });
    });
});